export interface TwoFactorQrPayload {
  secret?: string;
  secretURL?: string;
  otpauthUri?: string;
}

const QR_IMAGE_SERVICE = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=';

const DEPRECATED_QR_HOSTS = ['chart.googleapis.com', 'google.com/chart'];

export function buildOtpAuthUri(secret: string, email: string, issuer: string): string {
  const safeIssuer = (issuer || 'OficinaVirtual').trim();
  const safeEmail = (email || '').trim();
  return `otpauth://totp/${safeIssuer}:${safeEmail}?secret=${secret}&issuer=${safeIssuer}`;
}

export function buildQrImageUrl(otpauthUri: string): string {
  return `${QR_IMAGE_SERVICE}${encodeURIComponent(otpauthUri)}`;
}

function isDeprecatedQrUrl(url?: string): boolean {
  if (!url) {
    return true;
  }
  const normalized = url.toLowerCase();
  return DEPRECATED_QR_HOSTS.some(host => normalized.includes(host));
}

export function resolveTwoFactorQrImageUrl(
  qr: TwoFactorQrPayload | null | undefined,
  email: string,
  issuer = 'OficinaVirtual'
): string {
  if (!qr?.secret) {
    return '';
  }

  const otpauthUri = qr.otpauthUri || buildOtpAuthUri(qr.secret, email, issuer);
  const backendUrl = qr.secretURL?.trim();

  if (backendUrl && !isDeprecatedQrUrl(backendUrl)) {
    return backendUrl;
  }

  return buildQrImageUrl(otpauthUri);
}
